import { useEffect } from "react";
import type { FiltersDropDownItem } from "../../../../components/FiltersDropDown/FiltersDropDown";
import type { ListPageState } from "./useListPageState";

export interface ListPageFiltersConfig {
  statusFilters: FiltersDropDownItem[];
  accountManagerFilters: FiltersDropDownItem[];
  customerServiceRepFilters: FiltersDropDownItem[];
}

/**
 * Custom hook that manages filter synchronization between URL params and state
 */
export const useListPageFilters = (
  state: ListPageState,
  config: ListPageFiltersConfig
) => {
  const { statusFilters, accountManagerFilters, customerServiceRepFilters } =
    config;

  // Sync status filters with URL params
  useEffect(() => {
    if (state.query.status?.length && !state.selectedStatus.length) {
      state.setSelectedStatus(
        statusFilters.filter((item) => state.query.status!.includes(item.value))
      );
    }
  }, [
    state.query.account_managers,
    accountManagerFilters,
    state.selectedAccountManagers.length,
    state,
    statusFilters,
  ]);

  // Sync account managers with URL params
  useEffect(() => {
    if (
      state.query.account_managers?.length &&
      !state.selectedAccountManagers.length
    ) {
      state.setSelectedAccountManagers(
        accountManagerFilters.filter((item) =>
          state.query.account_managers!.includes(item.value)
        )
      );
    }
  }, [
    state.query.account_managers,
    accountManagerFilters,
    state.selectedAccountManagers.length,
    state,
  ]);

  // Sync customer service reps with URL params
  useEffect(() => {
    if (
      state.query.customer_service_reps?.length &&
      !state.selectedCustomerServiceReps.length
    ) {
      state.setSelectedCustomerServiceReps(
        customerServiceRepFilters.filter((item) =>
          state.query.customer_service_reps!.includes(item.value)
        )
      );
    }
  }, [
    state.query.customer_service_reps,
    customerServiceRepFilters,
    state.selectedCustomerServiceReps.length,
    state,
  ]);
};
